/**
 * Frontend mirrors of the backend coupon-send caps.
 *
 * Source of truth: `website/views/platform/affiliate_coupon_send_views.py`
 * (see todo/eng/eng-00148/api-contract.md). Keep these in sync — the UI uses
 * them to pre-empt 400s and to explain why sending is disabled, but the backend
 * enforces them.
 */

/** Recipients allowed in one bulk access-coupon request. */
export const ACCESS_SEND_MAX_RECIPIENTS_PER_REQUEST = 200;

/** Lifetime access coupons a single (sender, recipient) pair may exchange. */
export const ACCESS_COUPONS_PER_RECIPIENT_TOTAL = 3;

/** Minimum access coupons a recipient row must hold to be sendable. */
export const ACCESS_COUPON_MIN_PER_RECIPIENT = 1;
